var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('a',{on:{"click":function($event){return _vm.setOrderBy(_vm.col.value)}}},[_vm._v(_vm._s(_vm.col.text))]),(_vm.orderBy.includes('-' + _vm.col.value))?_c('v-icon',[_vm._v("mdi-chevron-down")]):_vm._e(),(_vm.orderBy.includes(_vm.col.value))?_c('v-icon',[_vm._v("mdi-chevron-up")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }